import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from '../components/home/HeroSection';
import CategoryGrid from '../components/home/CategoryGrid';
import SpotlightCardsRow from '../components/home/SpotlightCardsRow';
import HomeCommunitySections from '../components/home/HomeCommunitySections';
import { useLayoutViewport } from '../components/layout/LayoutViewportContext';

function HomePage() {
  const navigate = useNavigate();
  const { isMobile } = useLayoutViewport();

  const handleCategoryClick = (category) => {
    navigate(`/listings?category=${encodeURIComponent(category.slug || category.id)}`);
  };

  const handleViewAll = () => {
    navigate('/listings');
  };

  const handleExploreEvents = () => {
    navigate('/events');
  };

  const handleExploreDeals = () => {
    navigate('/offers');
  };

  return (
    <div className="animate-fade-in">
      <HeroSection
        onExploreDirectory={handleViewAll}
        onExploreDeals={handleExploreDeals}
        onExploreEvents={handleExploreEvents}
      />

      {!isMobile ? <CategoryGrid onCategoryClick={handleCategoryClick} /> : null}

      <SpotlightCardsRow />

      <HomeCommunitySections />
    </div>
  );
}

export default HomePage;
